import { Controller, useFormContext } from "react-hook-form";

import Grid from "@mui/material/Grid";

import { SupplierCategorySelect } from "../../../supplier-categories";
import { CustomInputField, CustomSelect } from "../../../ui";
import { SupplierTypeEnum, supplierTypeLabels } from "../../supplier-type";

export const GeneralInformationSection = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            required
            name="name"
            label="Nama"
            register={register}
            helperText={errors.name?.message}
            error={Boolean(errors.name)}
            InputProps={{
              placeholder: "Cth: John Doe",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            required
            control={control}
            name="code"
            label="Kode"
            register={register}
            helperText={errors.code?.message}
            error={Boolean(errors.code)}
            InputProps={{
              placeholder: "Cth: JAYA-ABADI-MDN",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="supplierCategory"
            render={({ field, fieldState }) => (
              <SupplierCategorySelect
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Kategori",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Controller
            control={control}
            name="type"
            render={({ field, fieldState }) => (
              <CustomSelect
                required
                value={field.value}
                onChange={field.onChange}
                id="type"
                label="Tipe Pemasok"
                options={Object.values(SupplierTypeEnum).map((value) => ({
                  value: value,
                  label: supplierTypeLabels[value],
                }))}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="telephoneNumber"
            label="No. Telp. Bisnis"
            register={register}
            helperText={errors.telephoneNumber?.message}
            error={Boolean(errors.telephoneNumber)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="phoneNumber"
            label="Handphone"
            register={register}
            helperText={errors.phoneNumber?.message}
            error={Boolean(errors.phoneNumber)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="whatsappNumber"
            label="No. Whatsapp"
            register={register}
            helperText={errors.whatsappNumber?.message}
            error={Boolean(errors.whatsappNumber)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="email"
            label="Email"
            register={register}
            helperText={errors.email?.message}
            error={Boolean(errors.email)}
            InputProps={{
              placeholder: "Cth: johndoe@mail.com",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="fax"
            label="Fax"
            register={register}
            helperText={errors.fax?.message}
            error={Boolean(errors.fax)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="website"
            label="Website"
            register={register}
            helperText={errors.website?.message}
            error={Boolean(errors.website)}
            InputProps={{
              placeholder: "Cth: https://cleancode.id",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 8, lg: 6 }}>
          <CustomInputField
            control={control}
            name="address"
            label="Alamat"
            register={register}
            helperText={errors.address?.message}
            error={Boolean(errors.address)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="postalCode"
            label="Kode POS"
            register={register}
            helperText={errors.postalCode?.message}
            error={Boolean(errors.postalCode)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="city"
            label="Kota"
            register={register}
            helperText={errors.city?.message}
            error={Boolean(errors.city)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="province"
            label="Provinsi"
            register={register}
            helperText={errors.province?.message}
            error={Boolean(errors.province)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="country"
            label="Negara"
            register={register}
            helperText={errors.country?.message}
            error={Boolean(errors.country)}
          />
        </Grid>
      </Grid>
  );
};

export default GeneralInformationSection;
